import { useEffect, useMemo, useState } from 'react';
import { subscribeToTeamSmsMessages } from '../services/firestoreService';
import userTeamService from '../services/userTeamService';
import { countUnreadSmsThreads } from '../utils/smsUnreadCount';

export function useTeamSmsUnreadCount(user, { enabled = true } = {}) {
  const [messages, setMessages] = useState([]);

  const smsConfig = useMemo(
    () =>
      user?.email && enabled
        ? userTeamService.getUserSmsConfig(user.email)
        : { smsNumber: null, smsEnabled: false },
    [user?.email, enabled]
  );

  useEffect(() => {
    if (!user?.email || !smsConfig.smsNumber) {
      setMessages([]);
      return () => {};
    }

    const unsubscribe = subscribeToTeamSmsMessages(smsConfig.smsNumber, setMessages);
    return () => unsubscribe();
  }, [user?.email, smsConfig.smsNumber]);

  return useMemo(
    () => countUnreadSmsThreads(messages, user?.email),
    [messages, user?.email]
  );
}
